module.exports = __webpack_public_path__ + "fonts/Roboto-LightItalic.43cbee7.ttf";